module.exports = __webpack_public_path__ + "img/1512062447.fe8a48b9.jpg";